import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "w100 mb20" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { class: "fl w30 pad10" }
const _hoisted_4 = { class: "fw600 pad10" }
const _hoisted_5 = ["src"]
const _hoisted_6 = {
  class: "mt10 pad10",
  style: {}
}
const _hoisted_7 = { key: 0 }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_9 = { class: "fl w60 mt30" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("p", null, "連携を有効にするには、担当者にお問い合わせください。", -1)
const _hoisted_11 = {
  key: 1,
  class: "w100"
}
const _hoisted_12 = { class: "fl w30 pad10" }
const _hoisted_13 = { class: "fw600 pad10" }
const _hoisted_14 = ["src"]
const _hoisted_15 = {
  class: "mt10 pad10",
  style: {}
}
const _hoisted_16 = { key: 0 }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_18 = {
  key: 0,
  class: "fl w60",
  style: {"margin-top":"20px"}
}
const _hoisted_19 = {
  class: "fl",
  style: {"width":"280px"}
}
const _hoisted_20 = { key: 1 }
const _hoisted_21 = { class: "fl fs14" }
const _hoisted_22 = {
  key: 1,
  class: "fl w60",
  style: {"margin-top":"20px"}
}
const _hoisted_23 = {
  class: "w100",
  style: {}
}
const _hoisted_24 = { key: 0 }
const _hoisted_25 = { key: 1 }
const _hoisted_26 = { key: 0 }
const _hoisted_27 = { key: 1 }
const _hoisted_28 = { key: 1 }
const _hoisted_29 = { class: "fl fs14 mt17" }
const _hoisted_30 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_31 = {
  key: 0,
  class: "mt10"
}
const _hoisted_32 = /*#__PURE__*/_createElementVNode("p", { class: "fs12" }, "送信するアクションを選択してください。", -1)
const _hoisted_33 = { key: 0 }
const _hoisted_34 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_35 = { key: 1 }
const _hoisted_36 = { class: "mt10 hoverLgreyBg pad5 rad8" }
const _hoisted_37 = {
  class: "fl fs13 mt3",
  style: {"width":"300px"}
}
const _hoisted_38 = { key: 0 }
const _hoisted_39 = { key: 0 }
const _hoisted_40 = {
  key: 0,
  class: "fl fs13 mt4 mr10 pointer"
}
const _hoisted_41 = {
  key: 1,
  class: "fl fs13 mt4 mr10 pointer"
}
const _hoisted_42 = { class: "fr mr5" }
const _hoisted_43 = ["src", "onClick"]
const _hoisted_44 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_45 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SelectTag = _resolveComponent("SelectTag")!
  const _component_MdTextfieldTag = _resolveComponent("MdTextfieldTag")!
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (!_ctx.rm.canUseOption(`management_hubspot`, false))
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("h5", _hoisted_4, [
              _createElementVNode("img", {
                src: _ctx.$getAssetImageUrl(`/assets/logo/logo_hubspot.png`),
                width: "28",
                height: "28",
                class: "pointer fl mr10",
                style: {"margin-top":"-8px"}
              }, null, 8, _hoisted_5),
              _createTextVNode("Hubspot連携 ")
            ]),
            _createElementVNode("p", _hoisted_6, [
              _createTextVNode(" Hubspot連携を行い、入力されたフォーム内容を連携することが可能です。 "),
              (_ctx.scope == `room_setting`)
                ? (_openBlock(), _createElementBlock("span", _hoisted_7, " 取引に追加する場合、dealstage_nameとpipeline_nameを入力できます。（未入力の場合は、defaultの項目に自動で追加されます。） "))
                : _createCommentVNode("", true)
            ]),
            _hoisted_8
          ]),
          _createElementVNode("div", _hoisted_9, [
            _hoisted_10,
            _createElementVNode("button", {
              type: "submit",
              class: "fl pointer centered circle_button skyblueBg fs14 rad8 mt15 mr20",
              style: {"height":"50px"},
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.requestHubspot && _ctx.requestHubspot(...args)))
            }, " リクエスト ")
          ])
        ]))
      : (_ctx.notiDic)
        ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
            _createElementVNode("div", _hoisted_12, [
              _createElementVNode("h5", _hoisted_13, [
                _createElementVNode("img", {
                  src: _ctx.$getAssetImageUrl(`/assets/logo/logo_hubspot.png`),
                  width: "28",
                  height: "28",
                  class: "pointer fl mr10",
                  style: {"margin-top":"-8px"}
                }, null, 8, _hoisted_14),
                _createTextVNode("Hubspot連携 ")
              ]),
              _createElementVNode("p", _hoisted_15, [
                _createTextVNode(" Hubspot連携を行い、入力されたフォーム内容を連携することが可能です。 "),
                (_ctx.scope == `room_setting`)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_16, " 取引に追加する場合、dealstage_nameとpipeline_nameを入力できます。（未入力の場合は、defaultの項目に自動で追加されます。） "))
                  : _createCommentVNode("", true)
              ]),
              _hoisted_17
            ]),
            (_ctx.scope == `user`)
              ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                  _createElementVNode("div", _hoisted_19, [
                    _createElementVNode("div", null, [
                      (_ctx.notiDic.id == `new`)
                        ? (_openBlock(), _createElementBlock("button", {
                            key: 0,
                            type: "submit",
                            class: "fl pointer centered circle_button skyblueBg fs14 rad8 mt15 mr20",
                            style: {"height":"50px"},
                            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.goHubspot && _ctx.goHubspot(...args)))
                          }, " OAuth連携 "))
                        : (_openBlock(), _createElementBlock("div", _hoisted_20, [
                            _createElementVNode("p", _hoisted_21, "連携HubspotアカウントID: " + _toDisplayString(_ctx.notiDic.settings.provider_account_id), 1),
                            _createElementVNode("button", {
                              type: "submit",
                              class: "fl pointer centered circle_button with_white_bg fs14 rad8 mt15 alertRed noborder underline mr20",
                              style: {"height":"50px"},
                              onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.removeHubspot && _ctx.removeHubspot(...args)))
                            }, " 連携解除 ")
                          ]))
                    ])
                  ])
                ]))
              : (_ctx.scope == `room_setting`)
                ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                    _createElementVNode("div", _hoisted_23, [
                      _createElementVNode("div", null, [
                        (_ctx.notiDic.id == `new`)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                              (!_ctx.connectableNotis)
                                ? (_openBlock(), _createElementBlock("button", {
                                    key: 0,
                                    type: "submit",
                                    class: "fl pointer centered circle_button skyblueBg fs14 rad8 mt15 mr20",
                                    style: {"height":"50px"},
                                    onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.connectHubspot && _ctx.connectHubspot(...args)))
                                  }, " 公開ページに紐付ける "))
                                : (_ctx.connectableNotis)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                                      (_ctx.connectableNotis.length == 0)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_26, "連携できるアカウントが見つかりませんでした。"))
                                        : (_ctx.connectableNotis.length >= 1)
                                          ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
                                              _createVNode(_component_SelectTag, {
                                                name: "select_hubspots",
                                                id: "select_hubspots",
                                                class: "fl fs14 roundForm w100",
                                                style: {"min-width":"30px","height":"50px","max-width":"150px"},
                                                options: _ctx.connectableNotis.map(noti => noti.settings.provider_account_id),
                                                defaultOption: null,
                                                needUnselect: true,
                                                onSelectValue: _ctx.selectHubspot
                                              }, null, 8, ["options", "onSelectValue"])
                                            ]))
                                          : _createCommentVNode("", true)
                                    ]))
                                  : _createCommentVNode("", true)
                            ]))
                          : (_openBlock(), _createElementBlock("div", _hoisted_28, [
                              _createElementVNode("p", _hoisted_29, "連携HubspotアカウントID: " + _toDisplayString(_ctx.notiDic.settings.provider_account_id), 1),
                              _createElementVNode("button", {
                                type: "submit",
                                class: "fl pointer centered circle_button with_white_bg fs14 rad8 alertRed noborder underline",
                                style: {"height":"50px"},
                                onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.disconnectHubspot && _ctx.disconnectHubspot(...args)))
                              }, " 解除 "),
                              _hoisted_30,
                              (_ctx.availableEvents && _ctx.showRegisterForm)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
                                    _hoisted_32,
                                    _createVNode(_component_SelectTag, {
                                      name: "select_available_events",
                                      id: "select_available_events",
                                      class: "fl fs14 roundForm w100 mr5",
                                      style: {"min-width":"30px","height":"50px","max-width":"120px"},
                                      options: _ctx.availableEvents.map(e => e.name),
                                      defaultOption: null,
                                      needUnselect: true,
                                      onSelectValue: _ctx.selectEvent
                                    }, null, 8, ["options", "onSelectValue"]),
                                    _createVNode(_component_SelectTag, {
                                      name: "select_register_type",
                                      id: "select_register_type",
                                      class: "fl fs14 roundForm w100 mr5",
                                      style: {"min-width":"30px","height":"50px","max-width":"180px"},
                                      options: _ctx.CustomNotification.hubspotRegisterTypes().map(m => m.name),
                                      defaultOption: null,
                                      needUnselect: true,
                                      onSelectValue: _ctx.selectRegisterType
                                    }, null, 8, ["options", "onSelectValue"]),
                                    (_ctx.registerType == `hs_meetings_and_deals`)
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_33, [
                                          _createVNode(_component_MdTextfieldTag, {
                                            fieldStyle: "min-width:280px;max-width:100%;",
                                            style: {"height":"56px","min-width":"280px","max-width":"100%"},
                                            class: "fl fs16",
                                            type: `dealstage_name`,
                                            name: `dealstage_name（取引名）`,
                                            placeholder: `dealstage_name（取引名）`,
                                            value: _ctx.defaultEventSettingDic.dealstage_name,
                                            onInputValue: _ctx.inputDealstageName,
                                            required: ""
                                          }, null, 8, ["value", "onInputValue"]),
                                          _createVNode(_component_MdTextfieldTag, {
                                            fieldStyle: "min-width:280px;max-width:100%;",
                                            style: {"height":"56px","min-width":"280px","max-width":"100%"},
                                            class: "fl fs16",
                                            type: `pipeline_name`,
                                            name: `pipeline_name（パイプライン名）`,
                                            placeholder: `pipeline_name（パイプライン名）`,
                                            value: _ctx.defaultEventSettingDic.pipeline_name,
                                            onInputValue: _ctx.inputPipelineName,
                                            required: ""
                                          }, null, 8, ["value", "onInputValue"])
                                        ]))
                                      : _createCommentVNode("", true),
                                    _createElementVNode("button", {
                                      type: "submit",
                                      class: "fl pointer centered circle_button fs14 rad8 noborder skyblueBg",
                                      style: {"height":"50px"},
                                      onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.addEvent && _ctx.addEvent(...args)))
                                    }, " 追加 ")
                                  ]))
                                : _createCommentVNode("", true),
                              _hoisted_34,
                              (_ctx.notiDic.events && _ctx.availableEvents)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_35, [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.notiDic.events, (ev, evindex) => {
                                      return (_openBlock(), _createElementBlock("div", { key: evindex }, [
                                        _createElementVNode("div", _hoisted_36, [
                                          _createElementVNode("div", _hoisted_37, [
                                            _createTextVNode(_toDisplayString(_ctx.availableEvents.find(e => e.timing == ev).name) + "時に ", 1),
                                            (_ctx.notiDic.settings[ev])
                                              ? (_openBlock(), _createElementBlock("span", _hoisted_38, _toDisplayString(_ctx.CustomNotification.hubspotRegisterTypes().find(
                                                        m => m.value == _ctx.notiDic.settings[ev].register_type
                                                    ).name), 1))
                                              : _createCommentVNode("", true)
                                          ]),
                                          (_ctx.notiDic.settings[ev])
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_39, [
                                                (_ctx.notiDic.settings[ev].pipeline_name)
                                                  ? (_openBlock(), _createElementBlock("div", _hoisted_40, [
                                                      _withDirectives((_openBlock(), _createElementBlock("span", null, [
                                                        _createTextVNode(" P ")
                                                      ])), [
                                                        [_directive_tooltip, `${_ctx.notiDic.settings[ev].pipeline_name}`]
                                                      ])
                                                    ]))
                                                  : _createCommentVNode("", true),
                                                (_ctx.notiDic.settings[ev].dealstage_name)
                                                  ? (_openBlock(), _createElementBlock("div", _hoisted_41, [
                                                      _withDirectives((_openBlock(), _createElementBlock("span", null, [
                                                        _createTextVNode(" D ")
                                                      ])), [
                                                        [_directive_tooltip, `${_ctx.notiDic.settings[ev].dealstage_name}`]
                                                      ])
                                                    ]))
                                                  : _createCommentVNode("", true)
                                              ]))
                                            : _createCommentVNode("", true),
                                          _createElementVNode("div", _hoisted_42, [
                                            _createElementVNode("img", {
                                              src: _ctx.$getAssetImageUrl(`/assets/icons/trash.png`),
                                              width: "20",
                                              height: "23",
                                              class: "pointer",
                                              onClick: ($event: any) => (_ctx.deleteSettingDic(ev))
                                            }, null, 8, _hoisted_43)
                                          ]),
                                          _hoisted_44
                                        ])
                                      ]))
                                    }), 128))
                                  ]))
                                : _createCommentVNode("", true)
                            ]))
                      ])
                    ])
                  ]))
                : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true),
    _hoisted_45
  ]))
}